// extracted by mini-css-extract-plugin
module.exports = {"thumbImage":"style__thumbImage__rAPqI","title":"style__title__PQefI","desc":"style__desc__J-WOM","item":"style__item__FrvhG","tags":"style__tags__KvCDh"};